import React from "react";
import {Button, Checkbox, Form, Icon, Input, message} from "antd";
import {connect} from "react-redux";
import {Link} from "react-router-dom";

import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignIn,
  userTwitterSignIn,
  getAccount
} from "appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;

class SignIn extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  handleSubmit = (e) => {
    if(e) e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true
        });

        this.props.showAuthLoader();
        this.props.userSignIn(values);
      }
    });
  };

  componentDidMount() {
    if (this.props.authUser) {
      this.props.history.push('/social-apps/accounts');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loading && this.props.showMessage &&
    prevProps.showMessage!= this.props.showMessage) {
      this.setState({
        loading: false
      });

      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.state.loading && !prevProps.authUser && this.props.authUser) {
      this.setState({
        loading: false
      });

      localStorage.setItem('bms-email', this.props.form.getFieldValue('email'));
      this.props.getAccount();
      this.props.history.push('/social-apps/accounts');
    }

    if (this.state.loading && !prevProps.error && this.props.error) {
      this.setState({
        loading: false
      });

      console.log('this.props.error', this.props.error);

      const type = this.props.error.type;

      if (type == 'NotAuthorizedException') {
        message.error("Invalid credentails or account hasn't been approved by the administrator");
      } else if (type == 'LimitExceededException'){
        message.error('You have changed password too many times recently. Please try again after a while.');
      } else if (type == 'InvalidParameterException') {
        message.error('Invalid password format. Password must be at least 8 characters.');
      } else if (type == 'AccountNotApproved') {
        message.error("Account hasn't been approved by the administrator. Please come back again later");
      } else if (type == 'UserNotFoundException') {
        message.error("This user is not found on the system");
      } else {
        message.error(type);
      }
    }
  }

  onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
      // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        this.handleSubmit();
      }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;

    return (
      <div className="gx-app-login-wrap gx-bg-light-blue">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div style={{width: '100%', height: '100%', background: 'url("' + require("assets/images/remote-access-control.png") + '")',
              backgroundPosition: 'center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}}></div>
            </div>
            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0">
                <FormItem style={{textAlign: 'center'}}>
                  <div className="gx-app-logo">
                    <img alt="example" src={require("assets/images/bms.jpeg")}/>
                  </div>
                </FormItem>
                <FormItem style={{textAlign: 'center', marginBottom: '50px'}}>
                  <h2>Welcome to BMS</h2>
                </FormItem>
                <FormItem style={{marginBottom: '36px'}}>
                  {getFieldDecorator('email', {
                    initialValue: "",
                    rules: [{
                      required: true, type: 'email', message: 'The input is not valid E-mail!',
                    }],
                  })(
                    <Input onKeyDown={this.onKeyDown} placeholder="Email"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    initialValue: "",
                    rules: [{required: true, message: 'Please input your Password!'}],
                  })(
                    <Input onKeyDown={this.onKeyDown} type="password" placeholder="Password"/>
                  )}
                </FormItem>
                <FormItem>
                  <span style={{float: 'right', lineHeight: 0, fontSize: '12px'}}><Link to="/forgotpassword">Forgot Password?</Link></span>
                </FormItem>
                <FormItem style={{textAlign: 'center'}}>
                  <Button style={{
                    boxShadow: '0 2px 0 2px rgba(0, 0, 0, 0.2)',
                    borderRadius: '10px',
                    minWidth: '80px'
                  }} type="primary" className="gx-mb-0" htmlType="submit" loading={this.state.loading}>
                    <IntlMessages id="app.userAuth.signIn"/>
                  </Button>
                </FormItem>
                <FormItem style={{textAlign: 'center'}}>
                  <span style={{fontSize: '12px'}}>New to BMS ? </span><Link style={{fontSize: '12px'}} to="/signup">Create Account</Link>
                </FormItem>
              </Form>
            </div>

            {this.state.loading ?
              <div className="gx-loader-view">
                <CircularProgress/>
              </div> : null}
          </div>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({auth, common}) => {
  const {loader, alertMessage, authUser} = auth;
  const {error} = common;
  return {loader, alertMessage, authUser, error}
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn,
  getAccount
})(WrappedNormalLoginForm);
